const ListingsList = () =>
	import(
		/* webpackChunkName: "listingslist"*/ "@/views/ListingsList/index.vue"
	);

const FacilityView = () =>
	import(/* webpackChunkName: "facilityview"*/ "@/views/Facility/index.vue");
const FacilityDashboard = () =>
	import(
		/* webpackChunkName: "facilitydashboard"*/ "@/views/Facility/Dashboard/index.vue"
	);
const FacilityPerformance = () =>
	import(
		/* webpackChunkName: "facilityperformance"*/ "@/views/Facility/Performance/index.vue"
	);
const FacilityLockdown = () =>
	import(
		/* webpackChunkName: "facilitylockdown"*/ "@/views/Facility/Lockdown/index.vue"
	);
const FacilityMessages = () =>
	import(
		/* webpackChunkName: "facilitymessages"*/ "@/views/Facility/Messages/index.vue"
	);
const FacilityPromotions = () =>
	import(
		/* webpackChunkName: "facilitypromotions"*/ "@/views/Facility/Promotions/index.vue"
	);
const FacilityVacancies = () =>
	import(
		/* webpackChunkName: "facilityvacancies"*/ "@/views/Facility/Vacancies/index.vue"
	);
const FacilityDetails = () =>
	import(
		/* webpackChunkName: "facilitydetails"*/ "@/views/Facility/Details/index.vue"
	);
const FacilitySettings = () =>
	import(
		/* webpackChunkName: "facilitysettings"*/ "@/views/Facility/Settings/index.vue"
	);
const FacilityHistory = () =>
	import(
		/* webpackChunkName: "facilityhistory"*/ "@/views/Facility/History/index.vue"
	);
const FacilityTeamRoles = () =>
	import(
		/* webpackChunkName: "facilityteamroles"*/ "@/views/Facility/TeamRoles/index.vue"
	);
const FacilityEditAllIn = () =>
	import(
		/* webpackChunkName: "facilityeditallin"*/ "@/views/Facility/Edit/AllIn.vue"
	);
const FacilityEditIndividual = () =>
	import(
		/* webpackChunkName: "facilityeditindividual"*/ "@/views/Facility/Edit/Individual.vue"
	);
const FacilityTodosView = () =>
	import(
		/* webpackChunkName: "facilitytodosview"*/ "@/views/Facility/Todos/index.vue"
	);

export default [
	{
		path: "listings",
		name: "Listings",
		component: ListingsList,
		meta: {
			title: "DailyAdmin - Supers listing list"
		}
	},
	{
		path: "listings/facility/:id",
		component: FacilityView,
		children: [
			{
				path: "",
				name: "FacilityDashboard",
				component: FacilityDashboard,
				meta: {
					title: "DailyAdmin - Listing dashboard"
				}
			},
			{
				path: "performance",
				name: "FacilityPerformance",
				component: FacilityPerformance,
				meta: {
					title: "DailyAdmin - Listing performance"
				}
			},
			{
				path: "lockdown",
				name: "FacilityLockdown",
				component: FacilityLockdown,
				meta: {
					title: "DailyAdmin - COVID-19"
				}
			},
			{
				path: "messages",
				name: "FacilityMessages",
				component: FacilityMessages,
				meta: {
					title: "DailyAdmin - Listing messages"
				}
			},
			{
				path: "vacancies",
				name: "FacilityVacancies",
				component: FacilityVacancies,
				meta: {
					title: "DailyAdmin - Listing vacancies"
				}
			},
			{
				path: "details",
				name: "FacilityDetails",
				component: FacilityDetails,
				meta: {
					title: "DailyAdmin - Listing details"
				}
			},
			{
				path: "promotions",
				name: "FacilityPromotions",
				component: FacilityPromotions,
				meta: {
					title: "DailyAdmin - Listing promotions"
				}
			},
			{
				path: "team-roles",
				name: "FacilityTeamRoles",
				component: FacilityTeamRoles,
				meta: {
					title: "DailyAdmin - Listing team"
				}
			},
			{
				path: "settings",
				name: "FacilitySettings",
				component: FacilitySettings,
				meta: {
					title: "DailyAdmin - Listing settings"
				}
			},
			{
				path: "history",
				name: "FacilityHistory",
				component: FacilityHistory,
				meta: {
					title: "DailyAdmin - Listing history"
				}
			}
		]
	},
	{
		path: "listings/facility/:id/edit/",
		name: "FacilityEditAllIn",
		component: FacilityEditAllIn,
		meta: {
			title: "DailyAdmin - Listing all edit"
		}
	},
	{
		path: "listings/facility/:id/edit/:form",
		name: "FacilityEditIndividual",
		component: FacilityEditIndividual,
		meta: {
			title: "DailyAdmin - Listing edit"
		}
	},
	{
		path: "listings/facility/:id/todos/:groupid",
		name: "FacilityTodosView",
		component: FacilityTodosView,
		meta: {
			title: "DailyAdmin - Listing todos"
		}
	}
];
